import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type tabIndex = number;

interface reportSlicePorps {
  reportTabIndex: tabIndex;
}

const initialState: reportSlicePorps = {
  reportTabIndex: 1,
};

const ReportSliceReducer = createSlice({
  name: "ReportSliceReducer",
  initialState,
  reducers: {
    setReportTabIndex(state, action: PayloadAction<tabIndex>) {
      state.reportTabIndex = action?.payload;
    },
  },
});

export const { setReportTabIndex } = ReportSliceReducer.actions;
export default ReportSliceReducer.reducer;
